import * as React from 'react';
import S from './FiltersFormContainer.styles';
const FiltersFormContainer = ({ children, type, subtitle, title, introduction, ...rest }) => {
    return (React.createElement(S.Container, { "data-type": type, ...rest },
        React.createElement(S.ContentWrapper, null,
            subtitle && React.createElement(S.Subtitle, null, subtitle),
            React.createElement(S.Title, null, title),
            introduction && React.createElement(S.Introduction, null, introduction)),
        React.createElement(S.FormWrapper, null, children)));
};
export default FiltersFormContainer;
